import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { achCopyLocationSchema } from './ach-copy-location-form.schema';

export const useACHLocationForm = () => {
  const form = useForm({
    resolver: yupResolver(achCopyLocationSchema),
    defaultValues: achCopyLocationSchema.cast({}),
  });

  useEffect(() => {
    form.reset({});
  }, [form]);

  return { form };
};
